enum RetireeType {
    Planner,
    Manager
}

export default RetireeType;
